import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { cloneDeep, get, set } from "lodash";

import { InvoiceTemplateContext } from "../InvoiceTemplateContext";

const additionalField = {
  editable: true,
  visible: true,
  canHide: true,
  hasValue: true,
  arrangeable: true,
  value: "Nhập nội dung",
  defaultValue: "",
  name: "ten_truong",
  style: {
    width: "100%",
    display: "inline-flex",
  },
  delimiterStyle: {},
  delimiter: ":",
  valueStyle: {
    fontSize: "14px",
  },
  label: {
    vi: "Nhập tên trường",
    en: "(Field name)",
  },
  labelStyle: {
    vi: {
      fontWeight: "bold",
      fontSize: "14px",
    },
    en: {
      fontStyle: "italic",
      fontSize: "13px",
    },
  },
};

const AddCustomFieldPopup = props => {
  const { isOpen, toggleModal } = props;

  const { state, dispatch } = useContext(InvoiceTemplateContext);
  const { selectedSection, invoiceData } = cloneDeep(state);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setFields([]);
    if (selectedSection) {
      const section = get(invoiceData, `${selectedSection}`);
      if (section.canAddCustomField) {
        const data = get(invoiceData, `${selectedSection}.fields`);
        const fieldData = data.filter(field => field.isCustomField);
        setFields(fieldData);
      }
    }
  }, [selectedSection]);

  const addField = () => {
    const fieldData = cloneDeep(fields);
    fieldData.push({
      ...cloneDeep(additionalField),
      isCustomField: true,
    });
    setFields(fieldData);
  };

  const updateValue = (key, value) => {
    const fieldData = cloneDeep(fields);
    set(fieldData, key, value);
    setFields(fieldData);
  };

  const removeField = index => {
    const data = fields.filter((field, i) => i !== index);
    setFields(data);
  };

  const handleSubmit = () => {
    let data = get(invoiceData, `${selectedSection}.fields`);
    data = data.filter(field => !field.isCustomField);
    data.push(...fields);

    dispatch({
      type: "updateInvoiceData",
      payload: { path: `${selectedSection}.fields`, value: data },
    });
    toggleModal();
  };

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      toggle={toggleModal}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggleModal}>
          Thêm mới các trường mở rộng
        </ModalHeader>
        <React.Fragment>
          <ModalBody>
            <Form>
              <Row>
                <Col>
                  <table className="table">
                    <thead>
                      <tr>
                        <td style={{ width: "4%" }}>STT</td>
                        <td style={{ width: "14%" }}>Tên Param</td>
                        <td style={{ width: "22%" }}>Tên trường</td>
                        <td style={{ width: "22%" }}>Song ngữ</td>
                        <td style={{ width: "22%" }}>Giá trị mặc định</td>
                        <td style={{ width: "11%" }}>Độ rộng</td>
                        <td style={{ width: "5%" }}></td>
                      </tr>
                    </thead>
                    <tbody>
                      {fields.map((field, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <Input
                              type="text"
                              className="form-control"
                              readOnly={!field.editable}
                              value={field.name}
                              onChange={event => {
                                updateValue(
                                  `[${index}].name`,
                                  event.target.value
                                );
                              }}
                            />
                          </td>
                          <td>
                            <Input
                              type="text"
                              className="form-control"
                              readOnly={!field.editable}
                              value={field.label.vi}
                              onChange={event => {
                                updateValue(
                                  `[${index}].label.vi`,
                                  event.target.value
                                );
                              }}
                            />
                          </td>
                          <td>
                            <Input
                              type="text"
                              className="form-control"
                              readOnly={!field.editable}
                              value={field.label.en}
                              onChange={event => {
                                updateValue(
                                  `[${index}].label.en`,
                                  event.target.value
                                );
                              }}
                            />
                          </td>

                          <td>
                            <Input
                              type="text"
                              className="form-control"
                              readOnly={!field.editable}
                              value={field.value || ""}
                              onChange={event => {
                                updateValue(
                                  `[${index}].value`,
                                  event.target.value
                                );
                              }}
                            />
                          </td>
                          <td>
                            <select
                              className="form-select"
                              value={field.style.width}
                              onChange={event => {
                                updateValue(
                                  `[${index}].style.width`,
                                  event.target.value
                                );
                              }}
                            >
                              <option value="50%">50%</option>
                              <option value="100%">100%</option>
                            </select>
                          </td>
                          <td>
                            <button
                              className="btn"
                              type="button"
                              onClick={() => removeField(index)}
                            >
                              <i className="fa fa-trash text-danger" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {fields?.length < 10 && (
                    <div className="mb-2 d-flex justify-content-between">
                      <div>Thêm mới tối đa 10 trường!</div>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => addField()}
                      >
                        <i className="bx bx-plus font-size-16 align-middle" />{" "}
                        Thêm
                      </button>
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Row className="justify-content-end">
              <Col className="col-auto">
                <Button
                  className="me-2 btn-label btn btn-danger"
                  type="button"
                  onClick={() => toggleModal()}
                >
                  <i className="bx bx-x label-icon" />
                  Hủy bỏ
                </Button>

                <Button
                  color="primary"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  <i className="bx bx-save label-icon"></i>
                  Lưu
                </Button>
              </Col>
            </Row>
          </ModalFooter>
        </React.Fragment>
      </div>
    </Modal>
  );
};

AddCustomFieldPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  employeeList: PropTypes.object,
  userRoleList: PropTypes.object,
  userPaymentMethodManager: PropTypes.object,
};

AddCustomFieldPopup.defaultProps = {
  userPaymentMethodManager: {},
  isOpen: false,
  dataDetail: {},
  mode: "",
  employeeList: {},
  userRoleList: {},
};

export default AddCustomFieldPopup;
